export default __webpack_public_path__ + "static/media/folio-joint.7129373c.svg";